import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function OpportunityDetailSkeleton() {
  return (
    <div className="space-y-4">
      {/* Two-column layout: left = header + score, right = parties + policy */}
      <div className="flex gap-4">
        {/* Left column */}
        <div className="min-w-0 flex-1 space-y-4">
          {/* Header row: back button + carrier/product left, status badge right */}
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-8 rounded-md" />
              <div className="space-y-1.5">
                <Skeleton className="h-7 w-56" />
                <Skeleton className="h-3.5 w-72" />
              </div>
            </div>
            <div className="shrink-0 text-right space-y-1.5">
              <Skeleton className="ml-auto h-6 w-16 rounded-full" />
              <Skeleton className="ml-auto h-3 w-28" />
            </div>
          </div>

          {/* Score Breakdown card */}
          <Card
            className="bg-gradient-card"
            style={{ boxShadow: 'var(--shadow-1), var(--inset-highlight)' }}
          >
            <CardHeader>
              <div className="flex items-center justify-between">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-4 w-20" />
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              {/* Score gauge */}
              <div className="flex items-center justify-center py-4">
                <Skeleton className="h-28 w-28 rounded-full" />
              </div>
              {/* Factor bars */}
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="space-y-1.5">
                  <div className="flex items-center justify-between">
                    <Skeleton className="h-3 w-24" />
                    <Skeleton className="h-3 w-12" />
                  </div>
                  <Skeleton className="h-2 w-full rounded-full" />
                </div>
              ))}
            </CardContent>
          </Card>
        </div>

        {/* Right column: related parties + policy stacked */}
        <div className="w-80 shrink-0 space-y-4">
          {/* Related-party card */}
          <Card
            className="bg-gradient-card"
            style={{ boxShadow: 'var(--shadow-1), var(--inset-highlight)' }}
          >
            <CardContent className="p-4 space-y-3">
              <Skeleton className="h-4 w-28" />
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} className="flex items-center justify-between">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-3 w-20" />
                </div>
              ))}
            </CardContent>
          </Card>

          {/* Policy card */}
          <Card
            className="bg-gradient-card"
            style={{ boxShadow: 'var(--shadow-1), var(--inset-highlight)' }}
          >
            <CardContent className="p-4 space-y-3">
              <Skeleton className="h-4 w-24" />
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={i} className="flex items-center justify-between">
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-3 w-24" />
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Comparison section placeholder */}
      <Card>
        <CardHeader>
          <Skeleton className="h-4 w-40" />
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex gap-2">
            <Skeleton className="h-7 w-20 rounded-md" />
            <Skeleton className="h-7 w-24 rounded-md" />
          </div>
          <div className="space-y-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="flex items-center gap-4">
                {[120, 80, 80, 80].map((w, col) => (
                  <Skeleton key={col} className="h-3" style={{ width: w }} />
                ))}
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Actions */}
      <div className="flex justify-end gap-3 border-t pt-4">
        <Skeleton className="h-9 w-28 rounded-md" />
      </div>
    </div>
  );
}
